// extracted by mini-css-extract-plugin
export default {"titlePage":"AppAPIKey_titlePage__gS6e3"};